export default __webpack_public_path__ + "static/media/7 raw.3398f783.mp3";